module.exports = new __parcel__URL__("albums.ab76531b.png").toString();